module.exports = __webpack_public_path__ + "img/infograph_9.12322ed7.png";